:host {
  display: block;
  user-select: none;

  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }
}

@keyframes adSlideIn {
  from {
    opacity: 0;
    translate: 20px 0;
  }

  to {
    opacity: 1;
    translate: 0 0;
  }
}

@keyframes adSlideInRtl {
  from {
    opacity: 0;
    translate: -20px 0;
  }

  to {
    opacity: 1;
    translate: 0 0;
  }
}

.AppSwitcher {
  display: flex;
  align-items: stretch;
  padding: var(--pdt-space-200) var(--pdt-space-150) var(--pdt-space-100);
  gap: var(--pdt-space-300);
  overflow: clip;

  eco-suite-navbar-app-switcher-ad {
    display: none;
  }

  @media (width >= 768px) {
    padding-block: var(--pdt-space-200);
    padding-inline: var(--pdt-space-150) var(--pdt-space-200);

    eco-suite-navbar-app-switcher-ad {
      display: flex;
      animation: adSlideIn .2s ease;

      :host(:dir(rtl)) & {
        animation-name: adSlideInRtl;
      }
    }

    .AppSwitcher__left {
      flex: 0 0 auto;
    }
  }

  &__left {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: var(--pdt-space-200);
  }

  &__list {
    display: flex;
    gap: var(--pdt-space-25);
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    list-style-type: none;
    padding: 0;
    margin: 0;

    li {
      width: 100%;
    }
  }

  &__item {
    display: flex;
    align-items: center;
    gap: var(--pdt-space-150);
    padding-block: var(--pdt-space-50);
    padding-inline: var(--pdt-space-50) var(--pdt-space-200);
    border-radius: var(--pdt-radius-150);
    width: 100%;
    cursor: pointer;
    text-decoration: none;
    color: inherit;
    border: 1px solid transparent;
    transition: background-color .2s ease;

    &-icon {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: var(--pdt-space-75);
      border-radius: 10px;
      flex-shrink: 0;
      border: 1px solid var(--pdt-color-border-alpha);
      color: var(--pdt-color-text);
      background-color: var(--pdt-color-control-bg);
      transition: all .2s ease;

      &--user-active {
        background-color: var(--pdt-color-bg-selected);
        color: var(--pdt-color-text-selected);
        border-color: transparent;
      }
    }

    &-label {
      font-size: var(--pdt-font-size-md);
      line-height: var(--pdt-line-height-2xs);
      color: var(--pdt-color-text, #16191d);
      font-weight: var(--pdt-font-weight-regular);
      white-space: nowrap;
      flex-grow: 1;

      &--user-active {
        font-weight: var(--pdt-font-weight-medium);
      }
    }

    &-link-type {
      opacity: 0;
      color: var(--pdt-color-text-medium);
    }

    &:hover {
      background-color: var(--pdt-color-bg-alpha-subtle-hovered);

      .AppSwitcher__item-icon--user-active {
        background-color: var(--pdt-color-control-bg);
        border-color: var(--pdt-color-border-alpha);
      }
    }

    &:active {
      background-color: var(--pdt-color-bg-alpha-subtle-pressed);

      .AppSwitcher__item-icon--user-active {
        background-color: var(--pdt-color-control-bg);
        border-color: var(--pdt-color-border-alpha);
      }
    }

    &:focus-visible {
      outline: 0;
      border-color: var(--pdt-color-border-focused);
      box-shadow: var(--pdt-shadow-focus);
    }

    &:hover,
    &:focus-visible {
      .AppSwitcher__item-link-type {
        opacity: 1;
      }
    }
  }

  &__all-apps {
    display: flex;
    align-items: center;
    gap: var(--pdt-space-75);
    margin-inline-start: var(--pdt-space-500);
    margin-top: var(--pdt-space-25);
    padding: var(--pdt-space-100) var(--pdt-space-150);
    text-decoration: none;
    color: var(--pdt-color-text-link);
    border: 1px solid transparent;
    border-radius: var(--pdt-radius-full);
    cursor: pointer;

    span {
      font-size: var(--pdt-text-body-sm-font-size);
      font-weight: var(--pdt-font-weight-semibold);
      line-height: var(--pdt-text-body-sm-line-height);
    }

    &:hover {
      text-decoration: underline;
    }

    &:focus-visible {
      border-color: var(--pdt-color-border-focused);
      box-shadow: var(--pdt-shadow-focus);
      outline: 0;
    }

    pwc-icon-shadow[icon="arrow-right"] {
      :host(:dir(rtl)) & {
        transform: scaleX(-1);
      }
    }
  }

  &--searching {
    padding: 0;
    overflow: auto;

    .AppSwitcher__list,
    eco-suite-navbar-app-switcher-ad {
      display: none;
    }

    .AppSwitcher__left {
      flex: 1;
    }
  }
}
